import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";

const AGBPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      <main className="pt-24 pb-16">
        <div className="max-w-4xl mx-auto px-4">
          <Link 
            to="/" 
            className="inline-flex items-center gap-2 text-gray-600 hover:text-black mb-8"
          >
            <ArrowLeft className="w-4 h-4" />
            Zurück zur Startseite
          </Link>
          
          <h1 className="font-nouvel text-4xl font-bold mb-8">Allgemeine Geschäftsbedingungen</h1>
          
          <div className="prose prose-lg max-w-none font-read">
            <h2 className="font-nouvel text-2xl font-bold mt-8 mb-4">§ 1 Geltungsbereich</h2>
            <p>
              (1) Diese Allgemeinen Geschäftsbedingungen (AGB) gelten für alle Verträge zwischen 
              Auto Thurm (nachfolgend "Verkäufer") und dem Kunden über den Kauf von Fahrzeugen 
              sowie für Werkstattleistungen.
            </p>
            <p>
              (2) Abweichende Bedingungen des Kunden werden nicht anerkannt, es sei denn, der 
              Verkäufer stimmt ihrer Geltung ausdrücklich schriftlich zu.
            </p>
            
            <h2 className="font-nouvel text-2xl font-bold mt-8 mb-4">§ 2 Vertragsschluss</h2>
            <p>
              (1) Die Darstellung der Fahrzeuge auf der Website stellt kein rechtlich bindendes 
              Angebot dar, sondern eine unverbindliche Aufforderung zur Abgabe eines Angebots.
            </p>
            <p>
              (2) Durch das Absenden einer Anfrage über die Website gibt der Kunde ein verbindliches 
              Angebot ab. Der Vertrag kommt erst durch schriftliche Bestätigung oder Ausführung der 
              Leistung durch den Verkäufer zustande.
            </p>
            
            <h2 className="font-nouvel text-2xl font-bold mt-8 mb-4">§ 3 Preise und Zahlung</h2>
            <p>
              (1) Die angegebenen Preise sind Endpreise inklusive der gesetzlichen Mehrwertsteuer.
            </p>
            <p>
              (2) Zusätzliche Kosten (z.B. Überführung, Zulassung) werden separat ausgewiesen.
            </p>
            <p>
              (3) Die Zahlung erfolgt nach Vereinbarung (Barzahlung, Überweisung, Finanzierung).
            </p>
            
            <h2 className="font-nouvel text-2xl font-bold mt-8 mb-4">§ 4 Werkstattleistungen</h2>
            <p>
              (1) Werkstatttermine können online oder telefonisch vereinbart werden.
            </p>
            <p>
              (2) Der Kunde ist verpflichtet, vereinbarte Termine einzuhalten oder rechtzeitig 
              (mindestens 24 Stunden vorher) abzusagen.
            </p>
            <p>
              (3) Kostenvoranschläge sind unverbindlich. Bei voraussichtlicher Überschreitung von 
              mehr als 15% wird der Kunde vorab informiert.
            </p>
            
            <h2 className="font-nouvel text-2xl font-bold mt-8 mb-4">§ 5 Reifeneinlagerung</h2>
            <p>
              (1) Die Einlagerung von Reifen erfolgt auf Risiko des Kunden.
            </p>
            <p>
              (2) Der Verkäufer haftet nur für Schäden, die durch grobe Fahrlässigkeit oder 
              Vorsatz entstehen.
            </p>
            <p>
              (3) Nicht abgeholte Reifen werden nach schriftlicher Mahnung und einer Frist von 
              6 Monaten kostenpflichtig entsorgt.
            </p>
            
            <h2 className="font-nouvel text-2xl font-bold mt-8 mb-4">§ 6 Gewährleistung</h2>
            <p>
              (1) Für Neufahrzeuge gilt die gesetzliche Gewährleistungsfrist von 2 Jahren.
            </p>
            <p>
              (2) Für Gebrauchtfahrzeuge kann die Gewährleistungsfrist auf 1 Jahr verkürzt werden.
            </p>
            <p>
              (3) Werkstattleistungen unterliegen einer Gewährleistung von 2 Jahren.
            </p>
            
            <h2 className="font-nouvel text-2xl font-bold mt-8 mb-4">§ 7 Haftung</h2>
            <p>
              (1) Der Verkäufer haftet unbeschränkt für Schäden aus der Verletzung des Lebens, 
              des Körpers oder der Gesundheit sowie für vorsätzlich oder grob fahrlässig 
              verursachte Schäden.
            </p>
            <p>
              (2) Im Übrigen ist die Haftung auf den vorhersehbaren, vertragstypischen Schaden 
              begrenzt.
            </p>
            
            <h2 className="font-nouvel text-2xl font-bold mt-8 mb-4">§ 8 Schlussbestimmungen</h2>
            <p>
              (1) Es gilt das Recht der Bundesrepublik Deutschland.
            </p>
            <p>
              (2) Gerichtsstand ist, soweit gesetzlich zulässig, der Sitz des Verkäufers.
            </p>
            <p>
              (3) Sollten einzelne Bestimmungen dieser AGB unwirksam sein, bleibt die Wirksamkeit 
              der übrigen Bestimmungen unberührt.
            </p>
            
            <div className="mt-12 p-4 bg-yellow-50 border-l-4 border-[#EFDF00]">
              <p className="text-sm text-gray-600">
                <strong>Hinweis:</strong> Diese AGB sind Muster-Bedingungen und müssen von einem 
                Rechtsanwalt an Ihre spezifischen Geschäftsprozesse angepasst werden.
              </p>
            </div>
            
            <p className="mt-8 text-sm text-gray-500">
              Stand: {new Date().toLocaleDateString('de-DE', { month: 'long', year: 'numeric' })}
            </p>
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default AGBPage;
